module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_8003.38f2a3fc.png";